export default {
  anyMistakes:
    'Als je het idee hebt dat er informatie op deze pagina staat die incorrect is, dan kun je',
  contactUs: 'contact opnemen',
  social: 'Wij zijn sociaal | Volg ons',
}
